/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Iconik_Publish_Publish_All_ButtonInputs */

const en_iconik_publish_publish_all_button = /** @type {(inputs: Iconik_Publish_Publish_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publish All`)
};

const fr_iconik_publish_publish_all_button = /** @type {(inputs: Iconik_Publish_Publish_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publier tout`)
};

const de_iconik_publish_publish_all_button = /** @type {(inputs: Iconik_Publish_Publish_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Alle veröffentlichen`)
};

const it_iconik_publish_publish_all_button = /** @type {(inputs: Iconik_Publish_Publish_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pubblica tutto`)
};

const ru_iconik_publish_publish_all_button = /** @type {(inputs: Iconik_Publish_Publish_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Опубликовать все`)
};

const es_iconik_publish_publish_all_button = /** @type {(inputs: Iconik_Publish_Publish_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar todo`)
};

const zh_cn2_iconik_publish_publish_all_button = /** @type {(inputs: Iconik_Publish_Publish_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`全部发布`)
};

const ja_iconik_publish_publish_all_button = /** @type {(inputs: Iconik_Publish_Publish_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`すべて公開`)
};

const hi_iconik_publish_publish_all_button = /** @type {(inputs: Iconik_Publish_Publish_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`सभी प्रकाशित करें`)
};

const pt_pt2_iconik_publish_publish_all_button = /** @type {(inputs: Iconik_Publish_Publish_All_ButtonInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Publicar tudo`)
};

/**
* | output |
* | --- |
* | "Publish All" |
*
* @param {Iconik_Publish_Publish_All_ButtonInputs} inputs
* @param {{ locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }} options
* @returns {LocalizedString}
*/
export const iconik_publish_publish_all_button = /** @type {((inputs?: Iconik_Publish_Publish_All_ButtonInputs, options?: { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Iconik_Publish_Publish_All_ButtonInputs, { locale?: "en" | "fr" | "de" | "it" | "ru" | "es" | "zh-CN" | "ja" | "hi" | "pt-PT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "fr") return fr_iconik_publish_publish_all_button(inputs)
	if (locale === "de") return de_iconik_publish_publish_all_button(inputs)
	if (locale === "it") return it_iconik_publish_publish_all_button(inputs)
	if (locale === "ru") return ru_iconik_publish_publish_all_button(inputs)
	if (locale === "es") return es_iconik_publish_publish_all_button(inputs)
	if (locale === "zh-CN") return zh_cn2_iconik_publish_publish_all_button(inputs)
	if (locale === "ja") return ja_iconik_publish_publish_all_button(inputs)
	if (locale === "hi") return hi_iconik_publish_publish_all_button(inputs)
	if (locale === "pt-PT") return pt_pt2_iconik_publish_publish_all_button(inputs)
	return en_iconik_publish_publish_all_button(inputs)
});